import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { BREADCRUMB_LD, SERVICE_LD, FAQ_LD } from "@/lib/ld/pickup";

export const Route = createFileRoute("/_app/pickup")({
  head: () =>
    buildHead({
      title: "Free Scrap Pickup at Your Doorstep | LohaLink India",
      description:
        "Book free doorstep pickup for iron, steel, metal and plastic scrap in India. Open weighing, live benchmark rates, GST invoicing and fast payment.",
      canonical: "/pickup",
      jsonLd: [BREADCRUMB_LD, SERVICE_LD, FAQ_LD],
    }),
  component: lazyRouteComponent(() => import("@/pages/Pickup")),
});
